import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'
import { isCornerPathWord } from '../wordAnalysis'

export const corneredCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  return (
    isAcceptedWordEntry(entry) &&
    isCornerPathWord(entry.path, entry.boardCols, entry.boardRows)
  )
}
